export default __webpack_public_path__ + "static/media/189001.e8675a98.png";